<template>
  <a-select
    show-search
    placeholder="请选择飞书群"
    style="width: 100%"
    :default-active-first-option="true"
    :filter-option="false"
    :not-found-content="null"
    @search="handleSearch"
    @change="handleChange"
    optionLabelProp="title"
  >
    <a-select-option v-for="item in list" :key="item.groupId" :value="item.groupId" :title="item.name">
      <div class="option-container">
        <a-avatar size="large" :src="item.avatar"></a-avatar>
        <div class="name-content">
          <div class="name">{{ item.name }}</div>
          <div class="description">{{ item.description }}</div>
        </div>
      </div>
    </a-select-option>
  </a-select>
</template>
<style lang="less" scoped>
.option-container {
  display: flex;
}
.name-content {
  margin-left: 10px;
}
.name {
  font-weight: bold;
}
.description {
  font-size: 12px;
}
</style>
<script>
import { getUserGroup } from '@/api/meeting';
export default {
  data() {
    return {
      list: [],
      selectValue: ''
    };
  },
  mounted() {
    this.getList();
  },

  methods: {
    handleSearch(value) {
      this.getList(value);
    },
    getList(name) {
      getUserGroup({
        groupName: name
      }).then(res => {
        if (res.code === 200) {
          this.list = res.data.items;
        }
      });
    },
    handleChange(value, e) {
      this.selectValue = value;
      let i = this.list.find(i => i.groupId === value);
      this.$emit('change', { ...i });
    }
  }
};
</script>
